import React from "react";
import CandidatesTable from "./CandidatesTable";

const CandidatesPage: React.FC = () => {
  return (
    <div className="">
      <CandidatesTable />
    </div>
  );
};

export default CandidatesPage;
